export default __webpack_public_path__ + "static/media/cookbook-unactive.12ef6fe8.svg";